import type { ColumnConfig } from '../types';

export const DEFAULT_COLUMN_CONFIG: ColumnConfig[] = [
  {
    id: 'rank',
    type: 'rank',
    csvHeader: 'rank',
    displayName: 'Rank',
    visible: true,
    visibleOnMobile: true
  },
  {
    id: 'bib_number',
    type: 'bib_number',
    csvHeader: 'bib_number',
    displayName: 'Bib',
    visible: true,
    visibleOnMobile: false
  },
  {
    id: 'name',
    type: 'name',
    csvHeader: 'name',
    displayName: 'Name',
    visible: true,
    visibleOnMobile: true
  },
  {
    id: 'gender',
    type: 'gender',
    csvHeader: 'gender',
    displayName: 'Gender',
    visible: true,
    visibleOnMobile: false
  },
  {
    id: 'gender_position',
    type: 'gender_position',
    csvHeader: 'gender_position',
    displayName: 'Gender Pos',
    visible: true,
    visibleOnMobile: false
  },
  {
    id: 'category',
    type: 'category',
    csvHeader: 'category',
    displayName: 'Category',
    visible: true,
    visibleOnMobile: false
  },
  {
    id: 'category_position',
    type: 'category_position',
    csvHeader: 'category_position',
    displayName: 'Category Pos',
    visible: true,
    visibleOnMobile: false
  },
  {
    id: 'club',
    type: 'club',
    csvHeader: 'club',
    displayName: 'Club',
    visible: true,
    visibleOnMobile: false
  },
  {
    id: 'chip_time',
    type: 'chip_time',
    csvHeader: 'chip_time',
    displayName: 'Chip Time',
    visible: true,
    visibleOnMobile: true
  },
  {
    id: 'gun_time',
    type: 'gun_time',
    csvHeader: 'gun_time',
    displayName: 'Gun Time',
    visible: true,
    visibleOnMobile: false
  },
  {
    id: 'custom_1',
    type: 'custom_1',
    csvHeader: 'custom_1',
    displayName: 'Custom 1',
    visible: false,
    visibleOnMobile: false
  },
  {
    id: 'custom_2',
    type: 'custom_2',
    csvHeader: 'custom_2',
    displayName: 'Custom 2',
    visible: false,
    visibleOnMobile: false
  }
];